<template>
    
  <div>

    <page-padding>
      <spinner v-if="showLoader"/>
      <!--<div v-if="!showLoader && !hasAbsences">{{$t('language.no_absences')}}</div>-->
    </page-padding>

   <infinite-list v-if="hasAbsences" :list="sortAbsences">

        <template v-slot:default="absence">
          
          <divider v-if="absence.item.divider && absence.item.absence" title="language.absent"></divider>
          <divider v-if="absence.item.divider && !absence.item.absence" title="language.not_absent"></divider>
          <button-child :item="absence.item" :key="absence.item.name+absence.item.parent_id"></button-child>
          <button-absence v-for="(absence) in absence.item.absences" :item="absence" :key="absence.id"></button-absence>
          
      </template>
    </infinite-list>


  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import ButtonAbsence from './ButtonAbsence.vue';
import Spinner from '../../components/Spinner';
import { eventBus } from '../../services/EventBus.js';
import ButtonChild from './ButtonChild.vue';
import Divider from '../../components/dividers/Divider.vue';

export default {
  name: 'list-absence',
  props:{
    group_id:{default:"0"},
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    InfiniteList,
    ButtonAbsence,
    Spinner,
    ButtonChild,
    Divider,
  },
  methods:{
     emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_absence(){
     this.emitLoadStart();
    
      this.$store.dispatch('get_absences',{store_key:this.group_id+"absences", group_id:this.group_id}).then(()=>{
        
        this.emitLoadEnd();
        
       
      })
    },
    plotDividerNotAbsent(item){
     if(!item.absence && !this.plottedDividerNonSick){
        
        this.plottedDividerNonSick=true;
        
        return true;
        

      }else{
        return false;
      }
      
    }
    
  },
  computed:{
    ...mapState([
       'absences','appSettings',
       ]),
       hasAbsences:function(){
         var store_key=this.group_id+"absences";
         
         if(this.absences[store_key]){
           return this.absences[store_key] ? this.absences[store_key].length : false;
         }else{
           return false;
         }
         
       },
       sortAbsences:function(){
        
         var store_key=this.group_id+"absences";
         
         //var nonSickDivider=false;
         //var sickDivider=false;

         // copy because not mutating data
         var sorted=[...this.absences[store_key]];
       
        // sort absences
         var absentList=sorted.filter((item)=>{
           return item.absence;
         })
         // sort alphabetically
         absentList = absentList.sort( (a ,b ) => {
            return a.name.localeCompare(b.name)
         });

         // sort NON absences
         var nonAbsentList=sorted.filter((item)=>{
           return !item.absence;
         })
         // sort alphabetically
         nonAbsentList = nonAbsentList.sort( (a ,b ) => {
            return a.name.localeCompare(b.name)
         });
         



        if(absentList[0]){
          absentList[0].divider=true;
        }
        if(nonAbsentList[0]){
          nonAbsentList[0].divider=true;
        }
        return [].concat(absentList).concat(nonAbsentList);
        /*


          sorted = sorted.sort( (a ,b ) => {
            if(a.absence){
              return true;
            }
            
            return a.name.localeCompare(b.name)
              //return (a.name - b.name);
          });

        */
         
         // get the first one of the non sick and set divider

/*
         sorted.forEach((item)=>{
           // mark for sick divider
           if(item.absence && !sickDivider ){
             item.divider=true;
             sickDivider=true;
           }
           // mark for non sick divider
           if(!item.absence && !nonSickDivider ){
             item.divider=true;
             nonSickDivider=true;
           }
         })

         return sorted;
         */
          
       }
       
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_absence)
    },
  created:function(){
    this.load_absence();
    eventBus.$on("RELOAD_FROM_PULL",this.load_absence)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>

